/* eslint-disable prettier/prettier */
import React from 'react';
import PropTypes from 'prop-types';
import { BasicButton } from '@adsk/alloy-react-button';
import { XIcon } from '@adsk/alloy-react-icon';
import Badge from '@adsk/alloy-react-badge';
import Divider from '@adsk/alloy-react-divider';
import { useLocale } from '@adsk/alloy-react-helpers';
import MemberAvatar from '../../../MemberAvatar';
import { COMPONENT_VARIANTS, MEMBER_STATUS } from '../../../constants';
import { phonePropType } from '../../../propTypes';
import { formatPhone, getAccountStatusText } from './utils';
import {
  activeColor,
  avatarContainer,
  badgeContainer,
  centerContainerStyles,
  dividerStyles,
  emailStyle,
  flexContainer,
  invitedColor,
  leftContainerStyle,
  mainContainerStyles,
  memberInfoHeaderTop,
  nameStyle,
  optionsMenuContainerStyles,
  phoneStyle,
  rightContainerStyles,
} from './styles';
import { ACCOUNT_STATUS_COLOR } from './constants';

const MemberInfo = ({
  email,
  imageUrl,
  memberId,
  name,
  onClose,
  optionsMenu,
  phone,
  status,
  variant,
}) => {
  const { T } = useLocale(({ locale }) => require(`../../i18n/${locale}.json`));

  return (
    <div css={mainContainerStyles}>
      <div css={flexContainer}>
        <div css={avatarContainer}>
          <MemberAvatar imageUrl={imageUrl} name={name} status={status} />
        </div>
        <div css={leftContainerStyle}>
          <div css={centerContainerStyles}>
            <div css={memberInfoHeaderTop}>
              <div css={nameStyle(status)}>{name}</div>
              <div css={rightContainerStyles(variant)}>
                <div css={optionsMenuContainerStyles}>
                  {memberId && optionsMenu}
                </div>
                <BasicButton
                  onClick={onClose}
                  data-testid="MemberProfilePanel_CloseButton"
                >
                  <XIcon />
                </BasicButton>
              </div>
            </div>
            <div css={phoneStyle(status)}>{formatPhone(phone, T)}</div>
            <a href={`mailto:${email}`} css={emailStyle}>
              {email}
            </a>
            {variant !== COMPONENT_VARIANTS.ACCOUNT &&
              (status === MEMBER_STATUS.ACTIVE ||
                status === MEMBER_STATUS.PENDING) && (
                <div css={badgeContainer}>
                  <Badge
                    color={
                      status === MEMBER_STATUS.ACTIVE
                        ? activeColor
                        : invitedColor
                    }
                  >
                    {status === MEMBER_STATUS.ACTIVE
                      ? T.translate('STATUS_ACTIVE')
                      : T.translate('STATUS_INVITED')}
                  </Badge>
                </div>
              )}
            {variant === COMPONENT_VARIANTS.ACCOUNT && (
              <div css={badgeContainer}>
                <Badge color={ACCOUNT_STATUS_COLOR[status]}>
                  {getAccountStatusText(status, T)}
                </Badge>
              </div>
            )}
          </div>
        </div>
      </div>
      <Divider style={dividerStyles} />
    </div>
  );
};

MemberInfo.propTypes = {
  email: PropTypes.string,
  imageUrl: PropTypes.string,
  memberId: PropTypes.string,
  name: PropTypes.string,
  onClose: PropTypes.func.isRequired,
  optionsMenu: PropTypes.node,
  phone: phonePropType,
  status: PropTypes.string,
  variant: PropTypes.oneOf(Object.values(COMPONENT_VARIANTS)),
};

export default MemberInfo;
